import { MARQUEE_ITEMS } from "../data/clinic";

const Row = () => (
    <div className="flex shrink-0 items-center">
        {MARQUEE_ITEMS.map((item, i) => (
            <span
                key={i}
                className="flex items-center gap-6 px-6 text-sm sm:text-base font-light tracking-[0.18em] uppercase text-emerald-100/70"
            >
                {item}
                <svg viewBox="0 0 12 12" className="h-2.5 w-2.5 fill-emerald-500">
                    <path d="M6 0l1.6 4.4L12 6 7.6 7.6 6 12 4.4 7.6 0 6l4.4-1.6z" />
                </svg>
            </span>
        ))}
    </div>
);

const Marquee = () => (
    <div
        data-testid="marquee-strip"
        className="marquee-hover relative overflow-hidden border-y border-emerald-500/15 bg-[#0b150e] py-5"
    >
        <div className="animate-marquee flex w-max">
            <Row />
            <Row />
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#060a07] to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#060a07] to-transparent" />
    </div>
);

export default Marquee;
